import http from 'conversations-http/clients/http';

// https://tools.hubteam.com/api-catalog/services/MessagesService/v2/spec/internal#operations-Associations-get-%2Fmessages%2Fv2%2Fassociations%2F%7BthreadId%7D

export const fetchThreadAssociations = ({
  threadId
}) => http.get(`messages/v2/associations/${threadId}`);